<form [formGroup]="form" (ngSubmit)="onSubmitForm($event)">
  <div class="form-group pt-2" formGroupName="sourceName">
    <label for="sourceName">
      {{ 'Settings::ZoomMeetingIntegrationSourceName' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="sourceName"
      formControlName="value" />
  </div>
  <div class="form-group pt-2" formGroupName="accountId">
    <label for="accountId">
      {{ 'Settings::ZoomMeetingIntegrationAccountId' | abpLocalization }}
    </label>
    <input
      type="text"
      class="form-control form-control-sm"
      id="accountId"
      formControlName="value" />
  </div>
  <button type="button" type="submit" class="btn btn-primary mt-3" [disabled]="!form.valid">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>
